/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/inbound/platform.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- APP
----------------------------------*/

import PlatformInboundLanding from '@/client/components/marketing/inbound/PlatformInboundLanding';

/*----------------------------------
- CONTROLEUR
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/inbound/platform', { ...({
  static: {
    refresh: '1h',
    urls: ['/inbound/platform']
  }
}), ...{ filepath: "/app/client/pages/inbound/platform.tsx", sourceLocation: { line: 12, column: 1 }, id: "inbound_platform" } }, null, () => <PlatformInboundLanding />);
};
